import { BackgroundCheckConfigByType } from './backgroundCheckConfig';

export const defaultBackgroundCheckConfigFilters: BackgroundCheckConfigByType['filter'] = {
    clear: ['completeClear'],
    ready: ['readyToSubmit'],
    failed: ['completeDenied', 'processingNeedsAttention'],
    processing: [
        'invalidSsn',
        'missingFields',
        'processingError',
        'processingPending',
        'processingResearching',
        'processingSubmitted',
        'reviewAndTakeAction',
    ],
};

export const manualBackgroundCheckConfigStatuses: BackgroundCheckConfigByType['statuses'] = [
    {
        status: 'didNotConsent',
        label: 'Did Not Consent',
        enabled: false,
    },
    {
        status: 'formIncomplete',
        label: 'Form Incomplete',
        enabled: false,
    },
    {
        status: 'unknown',
        label: 'Unknown',
        enabled: true,
    },
    {
        status: 'readyToSubmit',
        label: 'Ready to Submit',
        enabled: false,
    },
    {
        status: 'processingSubmitted',
        label: 'Processing: Submitted',
        enabled: true,
    },
    {
        status: 'processingPending',
        label: 'Processing: Submission Pending',
        enabled: true,
    },
    {
        status: 'processingResearching',
        label: 'Processing: Researching',
        enabled: true,
    },
    {
        status: 'processingError',
        label: 'Processing: Error',
        enabled: false,
    },
    {
        status: 'completeDenied',
        label: 'Complete: Denied',
        enabled: true,
    },
    {
        status: 'completeClear',
        label: 'Complete: Clear - No Matches Found',
        enabled: true,
    },
    {
        status: 'processingNeedsAttention',
        label: 'Processing: Needs Attention',
        enabled: true,
    },
    {
        status: 'missingFields',
        label: 'Required Fields Are Missing or Invalid',
        enabled: false,
    },
    {
        status: 'invalidSsn',
        label: 'Review and Take Action: Invalid SSN',
        enabled: false,
    },
    {
        status: 'reviewAndTakeAction',
        label: 'Review and Take Action: Possible Matches Found',
        enabled: false,
    },
];

export const autoBackgroundCheckConfigStatuses: BackgroundCheckConfigByType['statuses'] = [
    {
        status: 'didNotConsent',
        label: 'Did Not Consent',
        enabled: false,
    },
    {
        status: 'formIncomplete',
        label: 'Form Incomplete',
        enabled: false,
    },
    {
        status: 'unknown',
        label: 'Unknown',
        enabled: false,
    },
    {
        status: 'readyToSubmit',
        label: 'Ready to Submit',
        enabled: false,
    },
    {
        status: 'processingSubmitted',
        label: 'Processing: Submitted',
        enabled: false,
    },
    {
        status: 'processingPending',
        label: 'Processing: Submission Pending',
        enabled: false,
    },
    {
        status: 'processingResearching',
        label: 'Processing: Researching',
        enabled: false,
    },
    {
        status: 'processingError',
        label: 'Processing: Error',
        enabled: false,
    },
    {
        status: 'completeDenied',
        label: 'Complete: Denied',
        enabled: true,
    },
    {
        status: 'completeClear',
        label: 'Complete: Clear - No Matches Found',
        enabled: true,
    },
    {
        status: 'processingNeedsAttention',
        label: 'Processing: Needs Attention',
        enabled: false,
    },
    {
        status: 'missingFields',
        label: 'Required Fields Are Missing or Invalid',
        enabled: false,
    },
    {
        status: 'invalidSsn',
        label: 'Review and Take Action: Invalid SSN',
        enabled: false,
    },
    {
        status: 'reviewAndTakeAction',
        label: 'Review and Take Action: Possible Matches Found',
        enabled: false,
    },
];
